export enum CourseType {
  MTH_DIRECT = 'mth_direct',
  CUSTOM_BUILT = 'custom_built',
  THIRD_PARTY_PROVIDER = 'third_party_provider',
}
